import { render, staticRenderFns } from "./formgroupupload.vue?vue&type=template&id=923f6eca&"
import script from "./formgroupupload.vue?vue&type=script&lang=js&"
export * from "./formgroupupload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports